import { useTranslation } from 'react-i18next';
import type { ConsentEvent } from '@/lib/api/domains/consent.api';
import { cn, resolveLocale } from '@/lib/utils';

/**
 * One line of the consent journal: what happened, to which type, and when.
 * Shared by the participant journal and the account-agreement block (#1100) —
 * the two halves read the same table and must look the same.
 */
export function ConsentEventRow({ event }: { event: ConsentEvent }) {
  const { t } = useTranslation(['settings']);
  return (
    <div className="flex items-center justify-between p-3 rounded-lg border border-border bg-bg-surface">
      <div className="flex items-center gap-3">
        <span
          className={cn(
            'text-xs font-medium px-2 py-0.5 rounded',
            event.eventType === 'granted'
              ? 'bg-success-dim text-success-fg'
              : event.eventType === 'withdrawn'
                ? 'bg-danger-dim text-danger-fg'
                : 'bg-bg-muted text-fg-muted'
          )}
        >
          {t(`consent.eventTypes.${event.eventType}`, event.eventType)}
        </span>
        <span className="text-sm text-fg">
          {t(`consent.types.${event.consentType}`, event.consentType.replace(/_/g, ' '))}
        </span>
      </div>
      <span className="text-xs text-fg-muted">
        {/* The column allows NULL: a row without a time still shows, undated. */}
        {event.createdAt
          ? new Date(event.createdAt).toLocaleString(resolveLocale())
          : '—'}
      </span>
    </div>
  );
}
